import React from 'react';
import * as S from './Card.styles';
import PropTypes from 'prop-types';

const Card = ({
  borderRadius,
  spacing,
  hasHover,
  border,
  children,
  disabled,
  onClick,
  pressed,
  variant,
  modifier,
}) => (
  <S.Card
    borderRadius={borderRadius}
    spacing={spacing}
    hasHover={hasHover}
    border={border}
    disabled={disabled}
    onClick={onClick}
    pressed={pressed}
    hasCursorPointer={onClick && true}
    variant={variant}
    modifier={modifier}
  >
    {children}
  </S.Card>
);

const propTypesSpacing = PropTypes.oneOf([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
]);

Card.defaultProps = {
  spacing: '0',
  hasHover: false,
  disabled: false,
  pressed: false,
  borderRadius: true,
  variant: 'neutral',
  modifier: 'weak',
};

Card.propTypes = {
  spacing: PropTypes.oneOfType([
    propTypesSpacing,
    PropTypes.shape({
      top: propTypesSpacing,
      left: propTypesSpacing,
      right: propTypesSpacing,
      bottom: propTypesSpacing,
    }),
  ]),
  hasHover: PropTypes.bool,
  border: PropTypes.bool,
  disabled: PropTypes.bool,
  pressed: PropTypes.bool,
  borderRadius: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      topLeft: PropTypes.bool,
      topRight: PropTypes.bool,
      bottomLeft: PropTypes.bool,
      bottomRight: PropTypes.bool,
    }),
  ]),
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['neutral']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'weak']).isRequired,
};

export default Card;
